import Skeleton from "@mui/material/Skeleton";
import { styled } from "@mui/material/styles";

import { ProductNavigationContent, ProductNavigationWrapper } from "./ProductNavigationWrapper";

const NavigationItemSkeleton = styled("div")(({ theme }) => ({
    padding: theme.spacing(1, 1.5),
    height: 32,
    display: "flex",
    alignItems: "center",
    "&[data-last-item='false']": {
        borderBottom: `1px solid ${theme.palette.border.subtle}}`,
    },
}));

const navItems = [100, 150, 130, 100, 140, 150];

type ProductNavigationSkeletonProps = {
    headerHeight: number;
};

export function ProductNavigationSkeleton({ headerHeight }: ProductNavigationSkeletonProps) {
    return (
        <ProductNavigationWrapper>
            <ProductNavigationContent style={{ top: headerHeight }}>
                {navItems.map((width, index) => (
                    <NavigationItemSkeleton key={index} data-last-item={index === navItems.length - 1}>
                        <Skeleton variant="rectangular" height={20} width={width} />
                    </NavigationItemSkeleton>
                ))}
            </ProductNavigationContent>
        </ProductNavigationWrapper>
    );
}
